import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import API from '../services/api';
import { getSiteAyar } from '../services/api';
import kelebek from '../assets/kelebek.png';

// ── Takvim ───────────────────────────────────────────────────────────────────
function Takvim({ seciliTarih, onSecim, ayar9, ay, onAyDegis }) {
  const bugun = new Date(); bugun.setHours(0,0,0,0);
  const sinir = ayar9 === 1 ? new Date(bugun.getTime() + 86400000) : bugun;

  const AYLAR = ['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
  const GUNLER = ['Pt','Sl','Ça','Pe','Cu','Ct','Pa'];
  const yil = ay.getFullYear(), ayNo = ay.getMonth();
  let ilk = new Date(yil,ayNo,1).getDay()-1; if(ilk<0) ilk=6;
  const son = new Date(yil,ayNo+1,0).getDate();
  const hucre = [];
  for(let i=0;i<ilk;i++) hucre.push(null);
  for(let i=1;i<=son;i++) hucre.push(i);

  const sec = (gun) => {
    if(!gun) return;
    const d = new Date(yil,ayNo,gun); if(d<sinir) return;
    onSecim(`${yil}-${String(ayNo+1).padStart(2,'0')}-${String(gun).padStart(2,'0')}`);
  };

  const bugunkiIso = `${bugun.getFullYear()}-${String(bugun.getMonth()+1).padStart(2,'0')}-${String(bugun.getDate()).padStart(2,'0')}`;

  return (
    <table style={{ borderCollapse:'collapse', width:'100%', tableLayout:'fixed', fontFamily:'Tahoma', fontSize:13 }}>
      <thead>
        <tr>
          <td colSpan={7} style={{ background:'#1e4976', padding:'6px 8px' }}>
            <table style={{width:'100%'}}><tbody><tr>
              <td style={{width:24}}>
                <button onClick={()=>onAyDegis(new Date(yil,ayNo-1,1))} style={TK.navBtn}>◄</button>
              </td>
              <td style={{textAlign:'center',color:'#fff',fontWeight:700,fontSize:13,letterSpacing:0.5}}>
                {AYLAR[ayNo]} {yil}
              </td>
              <td style={{width:24,textAlign:'right'}}>
                <button onClick={()=>onAyDegis(new Date(yil,ayNo+1,1))} style={TK.navBtn}>►</button>
              </td>
            </tr></tbody></table>
          </td>
        </tr>
        <tr>
          {GUNLER.map(g=>(
            <td key={g} style={TK.thGun}>{g}</td>
          ))}
        </tr>
      </thead>
      <tbody>
        {Array.from({length:Math.ceil(hucre.length/7)},(_,r)=>(
          <tr key={r}>
            {hucre.slice(r*7,r*7+7).map((gun,ci)=>{
              if(!gun) return <td key={ci} style={TK.bos}/>;
              const iso=`${yil}-${String(ayNo+1).padStart(2,'0')}-${String(gun).padStart(2,'0')}`;
              const gecmis=new Date(yil,ayNo,gun)<sinir;
              const secili=iso===seciliTarih;
              const bugunMu=iso===bugunkiIso;
              const pazar=new Date(yil,ayNo,gun).getDay()===0;
              return (
                <td key={gun} onClick={()=>sec(gun)} style={{
                  ...TK.gun,
                  background: secili ? '#d05a10' : bugunMu ? '#dceffe' : '#fff',
                  color: secili ? '#fff' : gecmis ? '#ccc' : pazar ? '#c0392b' : '#1e3a5c',
                  fontWeight: secili ? 700 : bugunMu ? 700 : 400,
                  cursor: gecmis ? 'default' : 'pointer',
                  opacity: gecmis ? 0.5 : 1,
                }}>{gun}</td>
              );
            })}
            {hucre.slice(r*7,r*7+7).length<7 && Array.from({length:7-hucre.slice(r*7,r*7+7).length}).map((_,i)=><td key={`x${i}`} style={TK.bos}/>)}
          </tr>
        ))}
      </tbody>
    </table>
  );
}

const TK = {
  navBtn: { background:'none', border:'none', color:'#aed6ff', fontSize:14, cursor:'pointer', padding:0, lineHeight:1 },
  thGun:  { textAlign:'center', padding:'5px 0', background:'#e8f2ff', color:'#1e4976', fontWeight:700, fontSize:11, border:'1px solid #c8ddf0' },
  gun:    { textAlign:'center', padding:'5px 2px', border:'1px solid #dde8f5', fontSize:12 },
  bos:    { border:'1px solid #dde8f5', background:'#f9fbff' },
};

// ── 5 sn geri sayım ile otomatik sıfırlama ───────────────────────────────────
function BasariEkrani({ tarih, saat, tarihGoster, sifirla }) {
  const [kalan, setKalan] = React.useState(5);
  React.useEffect(() => {
    const t = setInterval(() => setKalan(k => k - 1), 1000);
    return () => clearInterval(t);
  }, []);
  React.useEffect(() => { if (kalan <= 0) sifirla(); }, [kalan, sifirla]);
  return (
    <div style={{background:'#fff',borderRadius:8,padding:16,boxShadow:'0 2px 8px rgba(0,0,0,0.08)',textAlign:'center'}}>
      <div style={{fontSize:32,marginBottom:8}}>✅</div>
      <div style={{color:'#1e5c30',fontWeight:700,fontSize:14,marginBottom:6}}>Randevunuz başarıyla alındı!</div>
      <div style={{color:'#2b5a8c',fontWeight:600,fontSize:13,marginBottom:16}}>
        {tarihGoster(tarih)}<br/>Saat: {saat}
      </div>
      <div style={{color:'#888',fontSize:11,marginBottom:10}}>{kalan} saniye sonra takvime dönülecek...</div>
      <button onClick={sifirla} style={S.btn}>Yeni Randevu Al</button>
    </div>
  );
}

// ── Sayfa kapsayıcısı — dışarıda tanımlı, her render'da yeniden oluşmaz ──────
function Kap({ doktorAdi, children }) {
  return (
    <div style={{fontFamily:'Tahoma,sans-serif',fontSize:13,background:'#f0f5fb',minHeight:'100vh',padding:'0 0 20px'}}>
      <div style={{background:'#1e4976',padding:'8px 12px',display:'flex',alignItems:'center',justifyContent:'center',gap:10}}>
        <img src={kelebek} width={50} height={35} alt="Dr.Plazma" style={{display:'block'}}/>
        <div style={{textAlign:'left'}}>
          <div style={{color:'#ffffff',fontWeight:700,fontSize:15,letterSpacing:0.5}}>Dr.Plazma</div>
          <div style={{color:'#90bfe8',fontSize:10}}>Online Randevu Sistemi</div>
        </div>
      </div>
      <div style={{background:'#2b6cb0',color:'#fff',textAlign:'center',padding:'7px 6px',fontSize:13,fontWeight:700,letterSpacing:0.3,borderBottom:'3px solid #f6a623'}}>
        {doktorAdi || ' '}
      </div>
      <div style={{padding:'10px 8px'}}>{children}</div>
      <div style={{color:'#8aaccc',textAlign:'center',fontSize:10,marginTop:4}}>
        Plazma Yazılım tarafından geliştirilmiştir
      </div>
    </div>
  );
}

// ── Ana bileşen ───────────────────────────────────────────────────────────────
export default function RandevuVerPublic() {
  const { siteId: siteIdStr, dokKod: dokKodStr } = useParams();
  const siteId = parseInt(siteIdStr) || 0;
  const dokKod = parseInt(dokKodStr) || 0;

  const isoTarih = (d) => `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-${String(d.getDate()).padStart(2,'0')}`;

  const [ayar9, setAyar9]         = useState(0);
  const [doktorAdi, setDoktorAdi] = useState('');
  const [tarih, setTarih]         = useState(isoTarih(new Date()));
  const [ay, setAy]               = useState(() => { const d=new Date(); return new Date(d.getFullYear(),d.getMonth(),1); });
  const [saat, setSaat]           = useState('');
  const [adSoy, setAdSoy]         = useState('');
  const [tcKimlik, setTcKimlik]   = useState('');
  const [cepTel, setCepTel]       = useState('');
  const [smsKodu, setSmsKodu]     = useState('');
  const [adim, setAdim]           = useState(1);

  const [bosSaatler, setBosSaatler] = useState([]);
  const [saatYukl, setSaatYukl]     = useState(false);
  const [saatMesaj, setSaatMesaj]   = useState('');
  const [yukleniyor, setYukl]       = useState(false);
  const [hata, setHata]             = useState('');
  const [mesaj, setMesaj]           = useState('');

  useEffect(() => {
    if (!siteId) return;
    API.get(`/Randevu/doktorlar?siteId=${siteId}&dokKod=${dokKod}`)
      .then(r => { const d=(r.data||[])[0]; if(d) setDoktorAdi(d.ad); })
      .catch(()=>{});
    getSiteAyar(siteId)
      .then(r => {
        setAyar9(r.data.ayar9 ?? 0);
      })
      .catch(()=>{});
  }, [siteId]);

  useEffect(() => {
    if (!tarih || !siteId) return;
    setSaat(''); setBosSaatler([]); setSaatMesaj(''); setSaatYukl(true);
    API.get(`/Randevu/bos-saatler?siteId=${siteId}&tarih=${tarih}${dokKod > 0 ? `&dokKodOverride=${dokKod}` : ''}`)
      .then(r => { if(r.data.mesaj) setSaatMesaj(r.data.mesaj); else setBosSaatler(r.data.saatler||[]); })
      .catch(()=>setSaatMesaj('Saatler yüklenemedi'))
      .finally(()=>setSaatYukl(false));
  }, [tarih, siteId]);

  const tarihGoster = (iso) => {
    if(!iso) return '';
    const d=new Date(iso);
    const aylar=['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'];
    const gunler=['Pazar','Pazartesi','Salı','Çarşamba','Perşembe','Cuma','Cumartesi'];
    return `${d.getDate()} ${aylar[d.getMonth()]} ${d.getFullYear()} ${gunler[d.getDay()]}`;
  };

  const smsYolla = async (e) => {
    e.preventDefault();
    if(!tarih){setHata('Lütfen tarih seçiniz');return;}
    if(!saat) {setHata('Lütfen saat seçiniz');return;}
    setHata(''); setYukl(true);
    try {
      const res = await API.post('/Randevu/sms-yolla',{siteId,dokKod,tarih,cepTel,tcKimlik,adSoy});
      if(res.data.başarılı){setMesaj(res.data.mesaj || 'SMS gönderildi. Telefonunuza gelen 4 haneli kodu giriniz.');setAdim(2);}
    } catch(err){setHata(err.response?.data?.hata||'SMS gönderilemedi');}
    finally{setYukl(false);}
  };

  const randevuKaydet = async (e) => {
    e.preventDefault();
    setHata(''); setYukl(true);
    try {
      const res = await API.post('/Randevu/kaydet',{siteId,dokKod,tarih,saat,adSoy,cepTel,tcKimlik,smsKodu});
      if(res.data.başarılı){setMesaj('Randevunuz başarıyla alındı!');setAdim(3);}
    } catch(err){setHata(err.response?.data?.hata||'Randevu kaydedilemedi');}
    finally{setYukl(false);}
  };

  const sifirla = () => {
    const d = new Date();
    setTarih(isoTarih(d));
    setAy(new Date(d.getFullYear(), d.getMonth(), 1));
    setSaat('');setAdSoy('');setTcKimlik('');setCepTel('');setSmsKodu('');
    setBosSaatler([]);setSaatMesaj('');setHata('');setMesaj('');setAdim(1);
  };

  // ADIM 3: Başarı
  if(adim===3) return (
    <Kap doktorAdi={doktorAdi}>
      <BasariEkrani tarih={tarih} saat={saat} tarihGoster={tarihGoster} sifirla={sifirla} />
    </Kap>
  );

  // ADIM 2: SMS kodu
  if(adim===2) return (
    <Kap doktorAdi={doktorAdi}>
      {mesaj && <div style={{background:'#e6f4ea',color:'#1e5c30',borderRadius:6,padding:10,marginBottom:8,fontSize:12,border:'1px solid #b6d8bf'}}>{mesaj}</div>}
      {hata  && <div style={{background:'#fdecea',color:'#8b1a1a',borderRadius:6,padding:10,marginBottom:8,fontSize:12,border:'1px solid #f5bcb8'}}>{hata}</div>}
      <div style={{background:'#fff',borderRadius:6,padding:10,marginBottom:10,border:'1px solid #c8ddf0',color:'#1e3a5c',fontWeight:700,fontSize:12}}>
        {tarihGoster(tarih)} — saat {saat}
      </div>
      <div style={{background:'#fff',borderRadius:8,padding:12,boxShadow:'0 2px 8px rgba(0,0,0,0.07)'}}>
        <div style={{marginBottom:8,fontSize:12,color:'#444'}}>Telefonunuza gelen SMS kodunu giriniz:</div>
        <form onSubmit={randevuKaydet}>
          <input style={{...S.input,fontSize:18,textAlign:'center',letterSpacing:6,fontWeight:700}}
            value={smsKodu} onChange={e=>setSmsKodu(e.target.value)}
            placeholder="_ _ _ _" maxLength="4" required autoFocus/>
          <div style={{display:'flex',gap:6,marginTop:10}}>
            <button style={S.btn} type="submit" disabled={yukleniyor}>{yukleniyor?'...':'Randevuyu Onayla'}</button>
            <button style={S.btnGri} type="button" onClick={()=>{setAdim(1);setHata('');setMesaj('');setSmsKodu('');}}>← Geri</button>
          </div>
        </form>
      </div>
    </Kap>
  );

  // ADIM 1: Takvim + Saatler + Form
  return (
    <Kap doktorAdi={doktorAdi}>
      {hata && <div style={{background:'#fdecea',color:'#8b1a1a',borderRadius:6,padding:8,marginBottom:8,fontSize:12,border:'1px solid #f5bcb8'}}>{hata}</div>}

      {/* Takvim */}
      <div style={{borderRadius:6,overflow:'hidden',border:'1px solid #c8ddf0',marginBottom:10,boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
        <Takvim seciliTarih={tarih} onSecim={setTarih} ayar9={ayar9} ay={ay} onAyDegis={setAy}/>
      </div>

      {/* Saat seçimi */}
      {tarih && (
        <div style={{marginBottom:10,borderRadius:6,overflow:'hidden',border:'1px solid #c8ddf0',boxShadow:'0 2px 6px rgba(0,0,0,0.06)'}}>
          <div style={{background:'#1e4976',color:'#fff',padding:'6px 10px',fontSize:12,fontWeight:700}}>
            {tarihGoster(tarih)}
          </div>
          <div style={{background:'#fff',padding:10,minHeight:40}}>
            {saatYukl && <div style={{color:'#888',fontSize:12}}>Saatler yükleniyor...</div>}
            {!saatYukl && saatMesaj && <div style={{color:'#c00',fontSize:12}}>{saatMesaj}</div>}
            {!saatYukl && !saatMesaj && bosSaatler.length===0 && <div style={{color:'#c00',fontSize:12}}>Bu tarihte uygun saat bulunmamaktadır.</div>}
            {!saatYukl && bosSaatler.length>0 && (
              <>
                <div style={{fontSize:11,fontWeight:700,color:'#1e4976',marginBottom:6}}>Saat Seçiniz</div>
                <div style={{display:'flex',flexWrap:'wrap',gap:'5px 12px'}}>
                  {bosSaatler.map(s=>(
                    <label key={s} style={{display:'flex',alignItems:'center',gap:4,cursor:'pointer',fontSize:12,
                      color: saat===s ? '#d05a10' : '#1e3a5c', fontWeight: saat===s ? 700 : 400}}>
                      <input type="radio" name="saat" value={s} checked={saat===s} onChange={()=>setSaat(s)} style={{cursor:'pointer'}}/>
                      {s}
                    </label>
                  ))}
                </div>
              </>
            )}
          </div>
        </div>
      )}

      {/* Form */}
      <div style={{background:'#fff',borderRadius:8,border:'1px solid #c8ddf0',boxShadow:'0 2px 6px rgba(0,0,0,0.06)',overflow:'hidden'}}>
        <div style={{background:'#e8f2ff',padding:'6px 10px',fontSize:11,fontWeight:700,color:'#1e4976',borderBottom:'1px solid #c8ddf0'}}>
          Randevu Bilgileri
        </div>
        <form onSubmit={smsYolla} style={{padding:10}}>
          <table style={{width:'100%',borderCollapse:'collapse'}}><tbody>
            <tr>
              <td style={S.td}>TC Kimlik No</td>
              <td style={S.td}><input style={S.input} value={tcKimlik} onChange={e=>setTcKimlik(e.target.value)} maxLength="11" required/></td>
            </tr>
            <tr>
              <td style={S.td}>Ad Soyad</td>
              <td style={S.td}><input style={S.input} value={adSoy} onChange={e=>setAdSoy(e.target.value)} required/></td>
            </tr>
            <tr>
              <td style={S.td}>Cep Telefonu</td>
              <td style={S.td}><input style={S.input} type="tel" value={cepTel} onChange={e=>setCepTel(e.target.value.replace(/\D/g,'').slice(0,10))} placeholder="5XX XXX XX XX" maxLength="10" required/></td>
            </tr>
          </tbody></table>
          <div style={{textAlign:'right',marginTop:10}}>
            <button style={S.btn} type="submit" disabled={yukleniyor}>
              {yukleniyor ? 'Gönderiliyor...' : 'SMS Kodu Yolla →'}
            </button>
          </div>
        </form>
      </div>
    </Kap>
  );
}

const S = {
  td:     { padding:'5px 4px', fontSize:12, color:'#1e3a5c', fontWeight:600, verticalAlign:'middle', whiteSpace:'nowrap' },
  input:  { padding:'5px 7px', border:'1px solid #c0d4ec', borderRadius:4, fontSize:12, fontFamily:'Tahoma', width:'100%', boxSizing:'border-box', background:'#f8fbff', outline:'none' },
  btn:    { padding:'8px 18px', background:'#1e4976', color:'#fff', border:'none', borderRadius:5, fontFamily:'Tahoma', fontSize:12, fontWeight:700, cursor:'pointer' },
  btnGri: { padding:'8px 14px', background:'#8a9ab0', color:'#fff', border:'none', borderRadius:5, fontFamily:'Tahoma', fontSize:12, fontWeight:700, cursor:'pointer' },
};
